require('./_wks-define')('observable');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/es7.symbol.observable.js
// module id = ../node_modules/core-js/modules/es7.symbol.observable.js
// module chunks = 1